
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/raja-kundalini",
      function () {
        return require("private-next-pages/raja-kundalini/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/raja-kundalini"])
      });
    }
  